export default {"src":"/_next/static/media/slalom.005a3bf2.svg","height":20,"width":50,"blurWidth":0,"blurHeight":0};